import { initFrontendSentry, parseTracesSampleRate } from '@masonic-tools/shared-utils/sentry';

const isProd = import.meta.env.MODE === 'production';

initFrontendSentry({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENV ?? import.meta.env.MODE,
  release: import.meta.env.VITE_SENTRY_RELEASE,
  tracesSampleRate: parseTracesSampleRate(
    import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE,
    isProd ? 0.1 : 1.0,
  ),
  appName: 'admin',
  enableReplay: import.meta.env.VITE_SENTRY_ENABLE_REPLAY !== 'false',
  replaysSessionSampleRate: parseTracesSampleRate(
    import.meta.env.VITE_SENTRY_REPLAY_SESSION_SAMPLE_RATE,
    0.1,
  ),
  replaysOnErrorSampleRate: parseTracesSampleRate(
    import.meta.env.VITE_SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE,
    1.0,
  ),
  enableLogs: import.meta.env.VITE_SENTRY_ENABLE_LOGS === 'true',
});
